<mat-dialog-content class="text-center pt-10 overflow-hidden w-140">
    <div class="mb-12" *ngIf="alertConfig.type === 'success'">
        <mat-icon svgIcon="streamline-regular:check-circle-1" color="accent"></mat-icon>
    </div>
    <div class="mb-12" *ngIf="alertConfig.type === 'info'">
        <mat-icon svgIcon="streamline-regular:information-circle" color="accent"></mat-icon>
    </div>
    <div class="mb-12" *ngIf="alertConfig.type === 'warning'">
        <mat-icon svgIcon="streamline-regular:alert-circle" color="accent"></mat-icon>
    </div>

    <div class="mt-1">
        <span class="intertitle text-primary" [innerHTML]="alertConfig.title"></span>
    </div>
    <div *ngIf="alertConfig.message" class="mt-4">
        <span class="text-primary" [innerHTML]="alertConfig.message"></span>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex flex-row-reverse justify-center items-center gap-6 w-full">
        <ng-container *ngFor="let button of alertConfig.buttons; let i = index">
            <button mat-flat-button class="py-6 px-5 w-44" color="accent" *ngIf="i === 0" (click)="confirm()">
                <span class="text-white">{{ button }}</span>
            </button>
            <button mat-flat-button class="py-6 px-5 w-44" (click)="close()" *ngIf="i !== 0">
                <span class="text-accent">{{ button }}</span>
            </button>
        </ng-container>
    </div>
</mat-dialog-actions>
